
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/website-support",
      function () {
        return require("private-next-pages/services/website-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/website-support"])
      });
    }
  